// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SummaryLoyaltyPoints_wrapper__pojXx","message":"SummaryLoyaltyPoints_message__I97_5"};